module.exports = __webpack_public_path__ + "static/media/windsock.163315ec.svg";